/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPdfSplitPreviewDocumentsInner
 */
export interface HchbPdfSplitPreviewDocumentsInner {
    /**
     * 
     */
    relation_type: HchbPdfSplitPreviewDocumentsInnerRelationTypeEnum;
    /**
     * 
     */
    relation_id: string;
    /**
     * 
     */
    generated_document_type?: HchbPdfSplitPreviewDocumentsInnerGeneratedDocumentTypeEnum;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    size_bytes: number;
    /**
     * 
     */
    estimated_parts: number;
}


/**
 * @export
 */
export const HchbPdfSplitPreviewDocumentsInnerRelationTypeEnum = {
    ScreenerDocument: 'screener_document',
    ScreenerAdditionalDocument: 'screener_additional_document',
    ScreenerGeneratedDocument: 'screener_generated_document',
} as const;
export type HchbPdfSplitPreviewDocumentsInnerRelationTypeEnum = typeof HchbPdfSplitPreviewDocumentsInnerRelationTypeEnum[keyof typeof HchbPdfSplitPreviewDocumentsInnerRelationTypeEnum];

/**
 * @export
 */
export const HchbPdfSplitPreviewDocumentsInnerGeneratedDocumentTypeEnum = {
    SummaryReport: 'summary_report',
    RulesReport: 'rules_report',
    DataPullsReport: 'data_pulls_report',
    SOffenderReport: 's_offender_report',
    MedicationsReport: 'medications_report',
    InsuranceEligibilityCheck: 'insurance_eligibility_check',
    AdvancedAiInsuranceCheck: 'advanced_ai_insurance_check',
    PalAuthSubmissionPackage: 'pal_auth_submission_package',
    PalCarveOutsPackage: 'pal_carve_outs_package',
    PalReauthSubmissionPackage: 'pal_reauth_submission_package',
    PdpmReport: 'pdpm_report',
    PccFaceSheetReport: 'pcc_face_sheet_report',
    PccOrderSummaryReport: 'pcc_order_summary_report',
    PccMdHistoryReport: 'pcc_md_history_report',
    PccDailySkilledNoteReport: 'pcc_daily_skilled_note_report',
    PccProgressNotesReport: 'pcc_progress_notes_report',
    PccWeightsVitalsReport: 'pcc_weights_vitals_report',
    PccLabResultsReport: 'pcc_lab_results_report',
    PccSocialServicesReport: 'pcc_social_services_report',
    PccSkinCheckReport: 'pcc_skin_check_report',
} as const;
export type HchbPdfSplitPreviewDocumentsInnerGeneratedDocumentTypeEnum = typeof HchbPdfSplitPreviewDocumentsInnerGeneratedDocumentTypeEnum[keyof typeof HchbPdfSplitPreviewDocumentsInnerGeneratedDocumentTypeEnum];


/**
 * Check if a given object implements the HchbPdfSplitPreviewDocumentsInner interface.
 */
export function instanceOfHchbPdfSplitPreviewDocumentsInner(value: object): value is HchbPdfSplitPreviewDocumentsInner {
    if (!('relation_type' in value) || value['relation_type'] === undefined) return false;
    if (!('relation_id' in value) || value['relation_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('size_bytes' in value) || value['size_bytes'] === undefined) return false;
    if (!('estimated_parts' in value) || value['estimated_parts'] === undefined) return false;
    return true;
}

export function HchbPdfSplitPreviewDocumentsInnerFromJSON(json: any): HchbPdfSplitPreviewDocumentsInner {
    return HchbPdfSplitPreviewDocumentsInnerFromJSONTyped(json, false);
}

export function HchbPdfSplitPreviewDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPdfSplitPreviewDocumentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'relation_type': json['relation_type'],
        'relation_id': json['relation_id'],
        'generated_document_type': json['generated_document_type'] == null ? undefined : json['generated_document_type'],
        'name': json['name'],
        'size_bytes': json['size_bytes'],
        'estimated_parts': json['estimated_parts'],
    };
}

export function HchbPdfSplitPreviewDocumentsInnerToJSON(json: any): HchbPdfSplitPreviewDocumentsInner {
    return HchbPdfSplitPreviewDocumentsInnerToJSONTyped(json, false);
}

export function HchbPdfSplitPreviewDocumentsInnerToJSONTyped(value?: HchbPdfSplitPreviewDocumentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relation_type': value['relation_type'],
        'relation_id': value['relation_id'],
        'generated_document_type': value['generated_document_type'],
        'name': value['name'],
        'size_bytes': value['size_bytes'],
        'estimated_parts': value['estimated_parts'],
    };
}

